import React, { useState } from 'react';
import Layout from '../../layout/Layout';
import { DASHBOARD_MODE, PROFILE } from '../../statics/localStorage';
import AttributeDashboard from './AttributeDashboard';
import LinkQrPageDashboard from './LinkQrPageDashboard';
import { encryptLocalStorage } from '../../utils/localStorage.utils';

const Dashboard = () => {

    const profileData = PROFILE();
    const dashboardModeLocal = DASHBOARD_MODE() || null;

    const [dashboardMode, setDashboardMode] = useState(dashboardModeLocal || 1);

    const toggleSwitch = (value) => {
        encryptLocalStorage('d-mode', value)
        setDashboardMode(value);
    }

    return (
        <Layout>
            <div className="p-3">

                <div className="flex flex-col items-center justify-center text-center bg-white p-6 rounded-2xl mb-4">
                    <p className="text-[17px] font-bold text-gray-900">Hi👋, {profileData?.name || "User"}</p>
                    <h1 className="text-2xl font-extrabold !text-primary mt-2">Welcome to Attriva.IO</h1>
                    <p className="text-sm text-gray-600 font-medium mt-1">
                        <span className="font-semibold text-blue-500">All in One Link Management Platform</span>
                    </p>
                    <p className="text-sm text-gray-500 mt-3">
                        Effortlessly manage, track, and optimize your links with ease.
                    </p>
                </div>

                <div className="relative w-[360px] p-[2px] bg-gray-200/50 rounded-full font-medium text-sm mx-auto mb-4 flex items-center cursor-pointer">
                    <div className="absolute w-1/2 h-full bg-white rounded-full shadow-md transition-transform duration-300 ease-in-out"
                        style={{ transform: dashboardMode == 2 ? "translateX(100%)" : "translateX(0%)" }}></div>
                    <div className="relative flex w-full h-full items-center justify-between">
                        <span className={`transition-colors w-full h-[45px] flex items-center justify-center font-medium duration-200 ${dashboardMode == 2 ? "text-gray-400" : "!text-primary"}`} onClick={() => toggleSwitch(1)}>
                            Link, QR, Pages
                        </span>
                        <span className={`transition-colors w-full h-[45px] flex items-center justify-center font-medium duration-200 ${dashboardMode == 2 ? "!text-primary" : "text-gray-400"}`} onClick={() => toggleSwitch(2)}>
                            Attribution
                        </span>
                    </div>
                </div>

                {dashboardMode === 1 && <LinkQrPageDashboard />}

                {dashboardMode === 2 && <AttributeDashboard />}

            </div>
        </Layout>
    )
}

export default Dashboard;